import axios from 'axios'
import * as FileSaver from 'file-saver'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import { XML_TYPE } from 'Utilities';

export async function postFileToUpdatePrices(carLotId,bussinessUnitType,file){
  const formData = new FormData();
  const nameExcelByBussinessUnit = {
    SavingsPlan: 'DetalledeimportacionPrecioplandeahorro.xlsx',
    "0Km": "Resultadodeimportación0km.xlsx",
    Usados: "ResultadodeimportaciónUsados.xlsx"
  }
  formData.append('file',file)
  formData.append('carlotid',carLotId)
  formData.append('type',bussinessUnitType)

  const report = await axios.post(`${CATALOGO_ENDPOINT}/uploadPriceFile`,formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'blob',
    timeout: 300000 // 5 minutos
  })
  if (report) {
    const generatedFile = new Blob([report.data], {
      type: XML_TYPE
    })
    FileSaver.saveAs(generatedFile, nameExcelByBussinessUnit[bussinessUnitType])
  }
  
  return report
}